class SearchBar

  active: false

  keys:
    BACKSPACE: 8
    TAB: 9
    ENTER: 13
    SHIFT: 16
    CTRL: 17
    ALT: 18
    ESC: 27
    SPACE: 32
    LEFT: 37
    UP: 38
    RIGHT: 39
    DOWN: 40

  constructor: ->
    @el = $('.twr-search-bar')
    @input = @el.find('#txt-search')

    @_render()
    @_bind()


  _render: ->
    @popoverEl = $('<div class="suggest-popover">
      <div class="items"></div>
      <a href="javascript:;" class="link-search-more">搜索更多内容...</a>
    </div>').appendTo @el

  _bind: ->
    @el.on 'click', '.link-search', (e) =>
      @el.addClass 'active'
      @el.one simple.util.transitionEnd(), =>
        @input.focus()[0].select()

    @el.on 'mousedown', '.link-search', (e) =>
      @_search @input.val().trim() if @el.hasClass('active')

    @el.on 'keyup', '#txt-search', @_keyup

    @el.on 'blur', '#txt-search', =>
      @active = false
      @el.removeClass 'active'
      @popoverEl.hide().find('.items').empty()
      false

    @el.on 'focus', '#txt-search', (e) =>
      @el.addClass 'active'
      false

    @popoverEl.on 'mouseenter', '.item', (e) ->
      $(@).addClass('selected').siblings('.selected').removeClass 'selected'

    @popoverEl.on 'mousedown', '.item', (e) =>
      @_select()
      false

    @popoverEl.on 'mouseenter', '.link-search-more', (e) =>
      @popoverEl.find('.selected').removeClass 'selected'

    @popoverEl.on 'mousedown', '.link-search-more', (e) =>
      @_search @input.val().trim()
      false


  _keyup: (e) =>
    keyword = @input.val().trim()
    @active = /^\d+$/.test(keyword)

    switch e.which
      when @keys.ESC
        @_hide()
      when @keys.SHIFT, @keys.CTRL, @keys.ALT, @keys.SPACE
        e.preventDefault()
      when @keys.UP
        @_changeFocus('prev')
      when @keys.DOWN
        @_changeFocus('next')
      when @keys.TAB, @keys.ENTER
        if @active then @_select(keyword) else @_search(keyword)
      else
        @_getItems(keyword) if @active

    @_hidePopover() unless @active


  _select: (keyword) ->
    $selected = @popoverEl.find('.item.selected')
    @_hide()
    if $selected.length
      tower.stack.load $selected.data('url'),
        root: true
    else
      @_search(keyword)

  _search: (keyword) =>
    return unless keyword
    @_hide()
    $('#page-search-result').empty()
    tower.stack.load "#{ @input.data('url') }?keyword=#{ encodeURIComponent(keyword) }",
      root: true

  _changeFocus: (type) ->
    $selected = @popoverEl.find('.item.selected')
    unless $selected.length
      @popoverEl.find('.item:first').addClass 'selected'
      return false

    $item = $selected["#{type}All"]('.item').first()
    return false unless $item.length

    $selected.removeClass 'selected'
    $item.addClass 'selected'

  _getItems: (keyword) =>
    @request.abort() if @request

    @request = $.ajax
      type: 'get'
      url: @el.data('suggest')
      data:
        q: keyword
        id_only: true
    .done (result) =>
      @_update(result.data)

  _update: (items) ->
    $items = @popoverEl.find('.items')
    $items.empty()

    if items.length
      @popoverEl.show()
    else
      @_hidePopover()
      return

    for item in items
      $items.append("""<a class="item" href="javascript:;" data-url="#{item.uri}">
                    <span><small>##{item.team_wide_id}</small> #{item.title}</span>
                  </a>""")

    @popoverEl.find('.item:first').addClass('selected').siblings('.selected').removeClass 'selected'

  _hide: =>
    @request.abort()if @request
    @active = false
    @el.removeClass 'active'
    @popoverEl.hide().find('.items').empty()
    @input.val('').trigger 'blur'

  _hidePopover: =>
    @active = false
    @popoverEl.hide().find('.items').empty()


tower.searchBar = ->
  new SearchBar
